<template>
  <el-card class="h-full">
    <div class="h-full flex flex-col">
      <span
        v-if="!(formProps.editType === 'read')"
        class="border-l-3 border-color-primary pl-10px text-18px"
        >作业活动危险源编辑</span
      >
      <div v-else>
        <el-page-header @back="$emit('cancel')" content="作业活动危险源详情"></el-page-header>
      </div>
      <div class="flex-1 overflow-y-auto mt-20px">
        <el-collapse v-model="collapseActiveName">
          <el-collapse-item title="风险点基本信息" name="baseInfo">
            <el-form
              v-loading="loading"
              ref="controlForm"
              label-width="150px"
              :model="controlForm"
              disabled
            >
              <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="作业活动名称" prop="jobName">
                    <el-input
                      v-model="pointInfo.jobName"
                      placeholder="请输入作业活动名称"
                      maxlength="50"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="作业活动类型" prop="jobActivityTypeText">
                    <el-input
                      v-model="pointInfo.jobActivityTypeText"
                      placeholder="请输入作业活动类型"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="作业活动内容" prop="jobContent">
                    <el-input
                      v-model="pointInfo.jobContent"
                      placeholder="请输入作业活动内容"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="作业活动编号" prop="jobNo">
                    <el-input
                      v-model="pointInfo.jobNo"
                      placeholder="请输入作业活动编号"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="作业实施单位" prop="jobImplementationUnitText">
                    <el-input
                      v-model="pointInfo.jobImplementationUnitText"
                      placeholder="请输入作业实施单位"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="作业活动区域" prop="jobActivityAreaText">
                    <el-input
                      v-model="pointInfo.jobActivityAreaText"
                      placeholder="请输入作业活动区域"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="涉及设备设施" prop="equipmentText">
                    <el-input
                      v-model="pointInfo.equipmentText"
                      placeholder="请输入涉及设备设施"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="作业活动频率" prop="jobActivityFrequencyText">
                    <el-input
                      v-model="pointInfo.jobActivityFrequencyText"
                      placeholder="请输入作业活动频率"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item
                    label="管控层级"
                    prop="controlHierarchy"
                    :rules="[
                      {
                        required: true,
                        message: '请输入管控层级',
                        trigger: ['blur', 'change'],
                      },
                    ]"
                  >
                    <el-select
                      class="w-full"
                      placeholder="请输入管控层级"
                      v-model="controlForm.controlHierarchy"
                      clearable
                    >
                      <el-option
                        v-for="item in controlHierarchyList"
                        :key="item.code"
                        :label="item.displayName"
                        :value="Number(item.code)"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item
                    ref="departmentSelect"
                    label="责任部门"
                    prop="organizationUnitId"
                    :rules="[
                      {
                        required: true,
                        message: '请输入责任部门',
                        trigger: ['blur', 'change'],
                      },
                    ]"
                  >
                    <department-select
                      v-model="controlForm.organizationUnitId"
                      :disabled="formProps.editType === 'read'"
                      @change="changeDepartment"
                    ></department-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item
                    label="责任人"
                    prop="leaderId"
                    :rules="[
                      {
                        required: true,
                        message: '请输入责任人',
                        trigger: ['blur', 'change'],
                      },
                    ]"
                  >
                    <el-select
                      v-model="controlForm.leaderId"
                      class="w-full"
                      placeholder="请选择责任人"
                      clearable
                      filterable
                      :disabled="formProps.editType === 'read'"
                    >
                      <el-option
                        v-for="item in userList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item
                    label="值班电话"
                    prop="dutyPhone"
                    :rules="[
                      {
                        pattern: /^1[3-9]{1}[0-9]{9}$/,
                        message: '请输入正确值班电话',
                        trigger: ['blur', 'change'],
                      },
                    ]"
                  >
                    <el-input
                      v-model="controlForm.dutyPhone"
                      placeholder="请选择值班电话"
                      maxlength="50"
                      clearable
                      :disabled="formProps.editType === 'read'"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item
                    label="应急电话"
                    prop="emergencyPhone"
                    :rules="[
                      {
                        pattern: /^1[3-9]{1}[0-9]{9}$/,
                        message: '请输入正确应急电话',
                        trigger: ['blur', 'change'],
                      },
                    ]"
                  >
                    <el-input
                      v-model="controlForm.emergencyPhone"
                      placeholder="请选择应急电话"
                      maxlength="50"
                      clearable
                      :disabled="formProps.editType === 'read'"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-collapse-item>
        </el-collapse>
        <BankCollapseList
          :evaluateMethod="formData.evaluateMethod"
          :list="formData.jobSourcesDangerIdentifyAssessDtos"
          :isEquip="false"
        />
      </div>
      <div class="flex justify-center mt-20px" v-if="formProps.editType !== 'read'">
        <el-button @click="$emit('cancel')" size="small">取消</el-button>
      </div>
    </div>
  </el-card>
</template>

<script>
import { EafOrganizationUnitUserApi } from '@wiz-api/account'
import DepartmentSelect from '@/components/safety/DepartmentSelect/DepartmentSelect'
import { JobSourcesDangerIdentifyApi } from '@wiz-api/double-prevention-management'
import utils from '@/components/safety/enumField/utils'
import BankCollapseList from '../business/BankCollapseList'

const jobSourcesDangerIdentifyApi = new JobSourcesDangerIdentifyApi()
const eafOrganizationUnitUserApi = new EafOrganizationUnitUserApi()
export default {
  name: 'bank-job-form',
  components: {
    BankCollapseList,
    DepartmentSelect,
  },
  props: {
    formData: {
      type: Object,
      default: () => {},
    },
    formProps: {
      default: () => {
        return {
          title: '新增作业活动辨识',
          editType: 'create',
          visible: true,
        }
      },
    },
  },
  data() {
    return {
      pointInfo: {
        jobActivityTypeText: '',
        jobName: '',
        jobContent: '',
        jobNo: '',
        jobImplementationUnitText: '',
        jobActivityAreaText: '',
        equipmentText: '',
        jobActivityFrequencyText: '',
      },
      showDialog: false,
      list: [],
      controlForm: {
        controlHierarchy: '',
        organizationUnitId: '',
        leaderId: '',
        dutyPhone: '',
        emergencyPhone: '',
      },
      tableFormData: {},
      tableData: [{ id: new Date().getTime() }],
      loading: false,
      collapseActiveName: ['baseInfo', 'risk'],
      accidentTypeList: [],
      controlHierarchyList: [],
      userList: [],
    }
  },
  watch: {},
  created() {
    utils.getDataCategory(
      ['DoublePreventionManagement.DataCategory.ControlHierarchy'],
      ['controlHierarchyList'],
      this
    )
    // 获取责任人
    Object.keys(this.controlForm).forEach((key) => {
      this.controlForm[key] = this.formData[key]
    })
    if (this.formData.jobActivityId) {
      this.getPointInfo(this.formData.jobActivityId)
    }
    this.getUserList()
  },
  mounted() {},

  methods: {
    async getPointInfo(id) {
      this.loading = true
      const [err, res] = await jobSourcesDangerIdentifyApi.getJobActivityInfo({
        sourcesDangerRecognitionPlanTaskId: id,
      })
      if (!err) {
        const { creationTime, ...otherData } = res
        this.pointInfo = {
          ...otherData,
        }
      }
      this.loading = false
    },
    // 切换责任部门
    changeDepartment(val) {
      this.$refs.departmentSelect.$emit('el.form.change')
      if (val) {
        this.getUserList()
        this.controlForm.leaderId = undefined
      } else {
        this.controlForm.leaderId = undefined
        this.userList = []
      }
    },
    // 获取用户列表
    async getUserList() {
      const [err, res] = await eafOrganizationUnitUserApi.getOrganizationUnitUserList({
        organizationUnitId: this.formData.responsibleDepartment,
        includeOrgChild: true, // 是否查询该部门子部门人员
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.userList = res.items
      }
    },
    createRow() {
      this.$refs.jobIdentify.createRow()
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-icon-arrow-right {
  display: none;
}
</style>
